import React from 'react'
import { useParams } from 'react-router-dom'
import { useEffectOnce } from 'react-use'
import { Container } from 'components/layout/Container'
import times from 'lodash/times'
import { Box, Typography, Skeleton } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import useTruckAvailability from 'apps/fleet-planner/hooks/useTruckAvailability'
import { useGetPublicTruckAvailability } from 'apps/fleet-planner/types'
import { Button } from 'transfix-ui'
import { BookableShipmentSavedSearchAvailableTrucksRow } from '../../components/bookable-shipment-saved-search/alert/BookableShipmentSavedSearchAvailableTrucksRow'
import { ShareHeader } from '../../components/share/ShareHeader'

export const SharedTruckAvailabiltyPage = () => {
  const { trackEvent } = useFMSAnalytics()
  const { isMobile } = useBreakpointContext()
  const { uuid } = useParams<{ uuid: string }>()
  const { data: getData, loading: isSavedSearchesLoading } = useGetPublicTruckAvailability({
    uuid,
  })
  const { bookableShipmentSavedSearches = [] } = getData || {}
  const { availableTruckDays = [], addBaseDaysChangeHandler } = useTruckAvailability({
    savedSearches: bookableShipmentSavedSearches,
    initialTotalBaseDays: 7,
  })

  const addSevenDaysClickHandler = () => {
    addBaseDaysChangeHandler(7)
  }

  // Track analytics eventss for viewing load details page.
  useEffectOnce(() => {
    trackEvent('Truck Availability', 'VIEWED_SHARED_TRUCK_AVAILABILITY_PAGE')
  })

  return (
    <div>
      <ShareHeader title='Available Trucks' />
      <Container hidePadding={!!isMobile}>
        <Box data-test='dispatcher-saved-searches-container' pt={11} px={2}>
          <Box p={1}>
            <Typography variant='subtitle1'>
              The dispatcher shared their truck availability with you. If you are able to fill any
              of these loads, please reach out to the carrier.
            </Typography>
          </Box>
          {isSavedSearchesLoading &&
            times(5).map(item => (
              <Box p={1} key={item}>
                <Box pt={2}>
                  <Skeleton variant='rectangular' height='50px' width='100%' />
                </Box>
              </Box>
            ))}
          {!isSavedSearchesLoading &&
            availableTruckDays.length > 0 &&
            availableTruckDays.map(availableTruckDay => {
              const { filteredSearches, pickupStartDate } = availableTruckDay || {}
              return (
                <Box pt={2} pb={2} key={pickupStartDate}>
                  <BookableShipmentSavedSearchAvailableTrucksRow
                    isSharedSavedSearch
                    pickupStartDate={pickupStartDate}
                    filteredSearches={filteredSearches}
                  />
                </Box>
              )
            })}
          <Box pt={2} display='flex' justifyContent='center'>
            <Button color='tertiary' onClick={addSevenDaysClickHandler}>
              Show 7 More Days
            </Button>
          </Box>
        </Box>
      </Container>
    </div>
  )
}
